import loadingCircle from '@assets/Icons/loading-circle.svg';
import Styles from './CircularProgress.module.scss';

export interface CircularProgressProps {
    centered?: boolean;
}

function CircularProgress({ centered = true }: CircularProgressProps = {}): React.ReactElement {
    if (centered) {
        return (
            <div className={Styles.centeredLoader}>
                <div className={Styles.circularProgress}>
                    <img src={loadingCircle} alt="Loading" />
                </div>
            </div>
        );
    }

    return (
        <div className={Styles.circularProgress}>
            <img src={loadingCircle} alt="Loading" />
        </div>
    );
}

export default CircularProgress;
